import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, QrCode } from 'lucide-react';
// Build a real vCard string so scanning the QR adds Eli & Ema to the contacts app.
const vCard = ['BEGIN:VCARD', 'VERSION:3.0', 'FN:Sestri za tačke', 'N:Sestri za tačke;;;;', 'ORG:Sestri za tačke', 'TITLE:Sprehajanje psov in skrb za hišne ljubljenčke', 'TEL;TYPE=CELL:+38640335549', 'TEL;TYPE=CELL:+38640334347', 'EMAIL;TYPE=INTERNET:sestrizatacke@siter.si', 'NOTE:Eli +386 40 335 549 · Ema +386 40 334 347', 'END:VCARD'].join('\n');
// Use a public QR generator that turns the vCard into a scannable code.
const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&margin=8&data=${encodeURIComponent(vCard)}`;
export function Contact() {
  return <section className="py-12 px-6 max-w-4xl mx-auto" id="kontakt" data-id="element-24">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="bg-white rounded-[3rem] p-6 md:p-10 shadow-soft text-center" data-id="element-25">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-brand-text mb-3" data-id="element-26">
          Kontakt
        </h2>
        <p className="text-lg md:text-xl text-brand-text/80 mb-6 font-medium" data-id="element-27">
          Z veseljem spoznava tudi vašega kužka 🐾
        </p>

        <div className="flex flex-col md:flex-row gap-8 items-center justify-center" data-id="element-28">
          {/* Contact Buttons */}
          <div className="flex flex-col gap-4 w-full md:w-1/2" data-id="element-29">
            <a href="mailto:sestrizatacke@siter.si" className="flex items-center justify-center gap-3 w-full py-4 px-6 bg-brand-pink-light hover:bg-brand-pink text-brand-text font-bold rounded-full transition-all duration-300 shadow-sm hover:shadow-md hover:-translate-y-1" data-id="element-30">
              <Mail className="w-5 h-5" data-id="element-31" />
              sestrizatacke@siter.si
            </a>

            <a href="tel:+38640335549" className="flex items-center justify-center gap-3 w-full py-4 px-6 bg-brand-brown-light hover:bg-brand-brown text-brand-text font-bold rounded-full transition-all duration-300 shadow-sm hover:shadow-md hover:-translate-y-1" data-id="element-32">
              <Phone className="w-5 h-5" data-id="element-33" />
              +386 40 335 549 (Eli)
            </a>

            <a href="tel:+38640334347" className="flex items-center justify-center gap-3 w-full py-4 px-6 bg-brand-green-light hover:bg-brand-green text-brand-text font-bold rounded-full transition-all duration-300 shadow-sm hover:shadow-md hover:-translate-y-1" data-id="element-34">
              <Phone className="w-5 h-5" data-id="element-35" />
              +386 40 334 347 (Ema)
            </a>
          </div>

          {/* vCard QR Code */}
          <div className="w-full md:w-1/2 flex flex-col items-center" data-id="element-36">
            <div className="bg-brand-cream p-4 rounded-[2rem] shadow-inner border-2 border-brand-brown/10 mb-4" data-id="element-37">
              <img src={qrSrc} alt="QR koda z vizitko Sestri za tačke" width={180} height={180} className="w-[180px] h-[180px] block" data-id="element-38" />
            </div>
            <p className="text-sm font-bold text-brand-text/60 flex items-center gap-2" data-id="element-39">
              <QrCode className="w-4 h-4" data-id="element-40" />
              Skeniraj in shrani najine podatke
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}